var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSignalBad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 15C13.1046 15 14 14.1046 14 13C14 11.8954 13.1046 11 12 11C10.8954 11 10 11.8954 10 13C10 14.1046 10.8954 15 12 15Z",
    fill: "#FF9E00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 13C18 9.7 15.3 7 12 7C8.7 7 6 9.7 6 13C6 15.2 7.2 17.1 9 18.2L10 16.5C8.8 15.8 8 14.5 8 13.1C8 10.9 9.8 9.1 12 9.1C14.2 9.1 16 10.9 16 13.1C16 14.6 15.2 15.9 14 16.5L15 18.2C16.8 17.2 18 15.2 18 13Z",
    fill: "#CBCBCB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3C6.5 3 2 7.5 2 13C2 16.7 4 19.9 7 21.6L8 19.9C5.6 18.5 4 15.9 4 13C4 8.6 7.6 5 12 5C16.4 5 20 8.6 20 13C20 16 18.4 18.5 16 19.9L17 21.6C20 19.9 22 16.7 22 13C22 7.5 17.5 3 12 3Z",
    fill: "#CBCBCB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignalBad);
export default __webpack_public_path__ + "static/media/signal_bad.b86324c8cb9dbd0b1a5031dc7de4236a.svg";
export { ForwardRef as ReactComponent };